<script lang="ts" context="module">
  import { getAppConfig } from '../../../../common/config/app-config';
  import { getStr, globalCurrencyTag, parseExtraCareData } from '../../../../common/util';
  import Icon from '../../../common/components/Icon.svelte';
  import PdpSafeguardTile from '../PDPSafeguardTile.svelte';
  import PdpServiceMiniCard from '../PDPServiceMiniCard.svelte';
  import { sendCartVasAdd, updateATCPopupTotalPrice, updateServiceHeaderAndHighlightInATCPopup } from './atc-utils';

  const { extraThemeResourcePath, currency } = getAppConfig();
</script>

<script lang="ts">
  export let data: any;
  export let labelData: any;
  export let product: any;
  export let selectedServices;

  // re-introduction of objects instead of indices
  let domEl;
  let activeTab = null;
  let activeTabSelectedOption = null;
  let activeTabSelectedOptionChildSelected = false;

  $: tabDisplay = data?.tabDisplay;
  $: activeTabSelectedOptionChild = (tabDisplay && activeTabSelectedOption?.child) || null;
  $: activeTabSelectedOptionChildVisible =
    tabDisplay &&
    !!activeTabSelectedOptionChild &&
    !!activeTab?.children?.find(c => c?.child?.vasType?.code === activeTabSelectedOptionChild?.vasType?.code);
  $: extraCareData = data && tabDisplay && parseExtraCareData(data);

  $: if (selectedServices) {
    if (selectedServices?.length > 0) {
      preSelectService(selectedServices);
    }
  }

  function onUpdateVasEntryNumbers(event: CustomEvent) {
    const updatedEntries = event.detail;
    console.log('[Service] Received updated vas entry numbers:', updatedEntries);
    if (!!updatedEntries && data.vasGroup in updatedEntries) {
      const newEntryNumber = updatedEntries[data.vasGroup];
      const thisServiceSelection = selectedServices?.find(s => s.vasGroup === data.vasGroup);
      if (thisServiceSelection) {
        thisServiceSelection.entryNumber = newEntryNumber;
        console.log('[Service] updated extra care service entry number to:', newEntryNumber);
      }
    }
  }

  function preSelectService(selectedServices) {
    activeTab = null;
    activeTabSelectedOption = null;
    activeTabSelectedOptionChildSelected = false;

    const allSelectedServiceCodes =
      selectedServices?.filter(s => s.vasGroup === data?.vasGroup)?.map(s => s.vasTypeCode) || [];

    if (tabDisplay) {
      // tabDisplay = true
      for (const tab of extraCareData) {
        for (const childItem of tab.children) {
          if (allSelectedServiceCodes.includes(childItem.vasType.code)) {
            setTimeout(() => {
              selectTab(tab);
              selectActiveTabOption(childItem, false);
            }, 250);
          } else if (!!childItem?.child && allSelectedServiceCodes.includes(childItem.child.vasType.code)) {
            selectTab(tab);
            setTimeout(() => {
              selectActiveTabOption(childItem, false);
              toggleActiveTabChildOption(false);
            }, 250);
          }
        }
      }
    } else {
      // tabDisplay = false
      for (const childItem of data.vasPrices) {
        if (allSelectedServiceCodes.includes(childItem.vasType.code)) {
          selectActiveTabOption(childItem, false);
        }
      }
    }
  }
  function selectTab(tabData) {
    const targetTabObject = extraCareData?.find(t => t.vasTypeGroupCode === tabData.vasTypeGroupCode);

    if (targetTabObject) {
      activeTab = targetTabObject;
    }
  }
  function selectActiveTabOption(activeTabOption, sendUpdate = true) {
    const targetTabOption = tabDisplay
      ? activeTab?.children?.find(t => t.vasType.code === activeTabOption.vasType.code)
      : data?.vasPrices?.find(t => t.vasType.code === activeTabOption.vasType.code);

    if (targetTabOption) {
      if (tabDisplay) {
        if (targetTabOption === activeTabSelectedOption) {
          // service is getting removed
          updateVasDetailsInCart(activeTabSelectedOption, activeTabSelectedOptionChildSelected, true);
          activeTabSelectedOption = null;
        } else {
          // service is getting added
          activeTabSelectedOption = targetTabOption;
          activeTabSelectedOptionChildSelected = false;
          if (sendUpdate) {
            updateVasDetailsInCart(activeTabSelectedOption, activeTabSelectedOptionChildSelected, false);
          }
        }
      } else {
        if (targetTabOption === activeTabSelectedOption) {
          // service is getting removed
          updateVasDetailsInCart(activeTabSelectedOption, activeTabSelectedOptionChildSelected, true);
          activeTabSelectedOption = null;
        } else {
          // service is getting added
          activeTabSelectedOption = targetTabOption;
          if (sendUpdate) {
            updateVasDetailsInCart(activeTabSelectedOption, activeTabSelectedOptionChildSelected, false);
          }
        }
      }
    }
  }

  function toggleActiveTabChildOption(sendUpdate = true) {
    activeTabSelectedOptionChildSelected = !activeTabSelectedOptionChildSelected;
    if (activeTabSelectedOptionChildSelected) {
      if (sendUpdate) {
        updateVasDetailsInCart(activeTabSelectedOption, activeTabSelectedOptionChildSelected, false);
      }
    } else {
      updateVasDetailsInCart(activeTabSelectedOption, activeTabSelectedOptionChildSelected, false);
    }
  }

  function updateVasDetailsInCart(
    activeTabSelectedOption,
    activeTabSelectedOptionChildSelected: boolean,
    removeService = false
  ) {
    const activeItem = activeTabSelectedOptionChildSelected ? activeTabSelectedOption.child : activeTabSelectedOption;

    if (activeItem) {
      const {
        productCodes,
        vasType: { code: vasType },
        priceType,
        priceTo,
        additionalAwsProductCode,
        additionalAwsVasGroup,
      } = activeItem || {};

      const selectedServiceItem = selectedServices?.find(s => s.vasGroup === data.vasGroup);

      const updateObject = {
        vasProductCode: productCodes?.length > 0 ? productCodes : data.serviceProductCode, //
        vasType,
        priceType,
        priceTo,
        productCode: product.code,
        additionalAwsProductCode,
        additionalAwsVasGroup,
        parentEntryNumber: selectedServiceItem?.parentEntryNumber ?? '',
        qty: 1,
        serviceGroupNumber: selectedServiceItem?.serviceGroupNumber ?? '',
        vasGroup: data.vasGroup,
        showApplyService: data.showApplyService,
        vasEntryShowService: data.showApplyService,
        entryNumber: selectedServiceItem?.entryNumber ?? '',
        CSRFToken: window.ACC.config.CSRFToken,
        defaultWarranty: removeService,
      };

      const url = `${window.ACC.config.encodedContextPath}/cart/vas/add`;
      return sendCartVasAdd(updateObject, url)
        .then((response: any) => {
          updateATCPopupTotalPrice(response.cartTotal);

          if (response?.entry) {
            const { entryNumber } = response.entry;
            const selectedServicesIndex = selectedServices?.findIndex(s => s.entryNumber === entryNumber);
            if (selectedServicesIndex > -1) {
              selectedServices.splice(selectedServicesIndex, 1, response.entry);
            } else {
              selectedServices = [response.entry];
            }
            window.ACC.mixpanel.trackServiceAddedToCart(
              response.cartData.entries[0].product,
              labelData.label,
              'Cart Popup',
              `${activeItem?.servicePrice?.formattedValue} ${currency}`,
              activeItem?.vasType?.label,
              'no addon',
              data.vasPrices?.findIndex(vp => vp.vasType.code === activeItem?.vasType?.code),
              response.cartData.mandateServiceSelectionEnabled
            );
          } else if (response.statusCode === 'VasEntryRemoved') {
            // service is removed
            if (selectedServices?.length > 0) {
              selectedServices = selectedServices.filter(s => s.entryNumber !== updateObject.entryNumber);
              window.ACC.vasaddtocart.updateEntryNumber(response);
            }
          }
        })
        .finally(() => queueMicrotask(updateServiceHeaderAndHighlightInATCPopup));
    }
  }
</script>

<svelte:window on:extra_updateVasEntryNumbers={onUpdateVasEntryNumbers} />
{#if (tabDisplay && extraCareData?.length > 0) || (!tabDisplay && data?.vasPrices?.length > 0)}
  <section class="atc-extra-care-details-wrapper" bind:this={domEl}>
    <PdpServiceMiniCard data={labelData} showLearnMore={true} serviceBlockType={data.serviceBlockType}>
      <section class="pdp-extra-care-service">
        {#if tabDisplay}
          <section class="base-tab-list">
            {#each extraCareData as tabData}
              <button
                class="extra-care-tab"
                class:active={tabData.vasTypeGroupCode === activeTab?.vasTypeGroupCode}
                on:click={() => selectTab(tabData)}
              >
                <h3 class="label">{tabData.vasTypeGroupName}</h3>
                <p class="subtitle">
                  <!-- Starts from <strong>SAR {tabData.minPrice}</strong> -->
                  {@html getStr('extra.care.tab.starts.from', [globalCurrencyTag, tabData.minPrice])}
                </p>
              </button>
            {/each}
          </section>
          {#each extraCareData as tabData}
            {#if tabData?.vasTypeGroupCode === activeTab?.vasTypeGroupCode && tabData?.children?.length > 0}
              <section class="active-tab-content">
                <p class="active-tab-subtitle">
                  <!-- Now go ahead and pick what fits you best! -->
                  {getStr('extra.care.tab.plans.taxt')}
                </p>
                <section class="active-tab-options">
                  {#each tabData.children as activeTabOption}
                    <PdpSafeguardTile
                      addonView={false}
                      data={activeTabOption}
                      active={activeTabOption?.vasType?.code === activeTabSelectedOption?.vasType?.code}
                      on:click={() => selectActiveTabOption(activeTabOption)}
                    />
                  {/each}
                </section>
              </section>
            {/if}
          {/each}
          {#if activeTabSelectedOptionChildVisible}
            <button
              on:click={() => toggleActiveTabChildOption()}
              class="active-tab-content-child"
              class:active={activeTabSelectedOptionChildSelected}
            >
              <img src="{extraThemeResourcePath}/images/extra-care-yellow-bg-img.svg" width="30" height="46" alt="" />
              <div class="message">
                <!-- Add SAR {activeTabSelectedOptionChild.priceDifference} now & enjoy {activeTabSelectedOptionChild.vasType.years} years of eXtra care benefits! -->
                {@html getStr('extra.care.upgrade.plans.taxt', [
                  globalCurrencyTag,
                  activeTabSelectedOptionChild.priceDifference,
                  activeTabSelectedOptionChild.vasType.name,
                ])}
              </div>
              <section class="check active-icon">
                {#if activeTabSelectedOptionChildSelected}
                  <Icon glyph="check" type="font" desktopSize={24} />
                {:else}
                  <section class="check-placeholder"></section>
                {/if}
              </section>
            </button>
          {/if}
        {:else}
          <section class="active-tab-content">
            <section class="active-tab-options">
              {#each data.vasPrices as activeTabOption}
                <PdpSafeguardTile
                  addonView={false}
                  data={activeTabOption}
                  active={activeTabOption?.vasType?.code === activeTabSelectedOption?.vasType?.code}
                  on:click={() => selectActiveTabOption(activeTabOption)}
                />
              {/each}
            </section>
          </section>
        {/if}
      </section>
    </PdpServiceMiniCard>
  </section>
{/if}

<style lang="scss">
  @import '../../../common/styles/colors.new.scss';
  .base-tab-list {
    display: flex;
    gap: 8px;
  }
  .extra-care-tab {
    background: $primary-white;
    border: 1px solid $secondary-gray-02;
    border-radius: 12px;
    padding: 12px 16px;
    flex-grow: 1;
    text-align: left;

    &.active {
      border-color: $primary-blue;
    }

    .label,
    .subtitle {
      font-size: 12px;
      line-height: 14px;
      font-weight: 400;
      color: $neutral-dark-03;
      margin: 0;
    }
    .subtitle {
      margin-top: 8px !important;

      strong {
        color: $primary-black;
      }
    }
  }

  .active-tab-content {
    padding-top: 12px;
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .active-tab-options {
    display: flex;
    gap: 8px;
    flex-wrap: wrap;

    & > :global(button.vas-price-tile) {
      flex-basis: calc(50% - 4px);
      flex-grow: 0;
    }
  }

  .active-tab-content-child {
    margin-top: 16px;
    border: 1px solid $functional-yellow;
    border-radius: 8px;
    background-color: rgba($functional-yellow, 10%);
    display: flex;
    align-items: center;
    gap: 16px;
    padding-inline: 10px;
    cursor: pointer;
    text-align: left;
    width: 100%;

    .message {
      font-size: 12px;
      line-height: 14px;
      font-weight: 700;
      color: $neutral-dark-01;
    }
    .check {
      color: $primary-blue;
      margin-left: auto;

      .check-placeholder {
        width: 20px;
        height: 20px;
        border-radius: 50%;
        border: 1px solid $primary-blue;
        margin-inline: 2px;
      }
    }

    &:not(.active) {
      :global(i::after) {
        content: '';
        position: absolute;
        inset: 0;
        border: 1px solid red;
        border-radius: 50%;
        display: block;
        top: 4px;
        left: 2px;
        right: 2px;
        bottom: 4px;
        background: white;
      }
    }
  }
  .atc-extra-care-details-wrapper {
    :global {
      .pdp-service-mini-card {
        background-color: transparent;
        padding: 0;
        .content {
          margin-top: 16px;
        }
      }
    }
  }
</style>
